import React from 'react';
import { 
  HelpCircle, 
  FileText, 
  Calculator, 
  Percent, 
  DollarSign, 
  BookOpen,
  AlertTriangle,
  TrendingUp
} from 'lucide-react';

/**
 * Компонент с советами по НДС
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Calculator,
      title: 'Как начислить НДС',
      description: 'Умножьте сумму без НДС на коэффициент (1 + ставка/100). Например: 100 руб × 1.2 = 120 руб.'
    },
    {
      icon: Percent,
      title: 'Как выделить НДС',
      description: 'Разделите сумму с НДС на (1 + ставка/100). Для НДС 20%: сумма с НДС ÷ 1.2.'
    },
    {
      icon: FileText,
      title: 'Оформление счетов-фактур',
      description: 'В счетах-фактурах необходимо отдельно указывать стоимость без НДС, сумму НДС и общую сумму.'
    },
    {
      icon: DollarSign,
      title: 'Округление сумм',
      description: 'Суммы НДС рекомендуется округлять до копеек (2 знака после запятой).'
    },
    {
      icon: BookOpen,
      title: 'Налоговый вычет',
      description: 'Организации могут получить вычет по НДС, если есть правильно оформленные счета-фактуры от поставщиков.'
    },
    {
      icon: AlertTriangle,
      title: 'Безопасная доля вычетов',
      description: 'Доля вычетов НДС более 89% от начисленного налога может привлечь внимание налоговых органов.'
    },
    {
      icon: TrendingUp,
      title: 'Возмещение НДС',
      description: 'Экспортеры имеют право на возмещение НДС при подтверждении факта экспорта.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-green-500" />
        Советы по НДС
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Нужна профессиональная консультация?
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              По вопросам налогообложения рекомендуем обращаться к квалифицированным бухгалтерам и налоговым консультантам.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Найти специалиста
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;